import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/admin/Dashboard';
import Estabelecimentos from './pages/admin/Estabelecimentos';
import Produtos from './pages/admin/Produtos';
import Pedidos from './pages/admin/Pedidos';
import Faturamento from './pages/admin/Faturamento';
import Cardapio from './pages/admin/Cardapio';
import Categorias from './pages/admin/Categorias';
import Adicionais from './pages/admin/Adicionais';
import Cozinha from './pages/admin/Cozinha';
import Entregas from './pages/admin/Entregas';
import Caixa from './pages/admin/Caixa';
import Financeiro from './pages/admin/Financeiro';
import Estoque from './pages/admin/Estoque';
import Compras from './pages/admin/Compras';
import Cupons from './pages/admin/Cupons';
import Funcionarios from './pages/admin/Funcionarios';
import Entregadores from './pages/admin/Entregadores';
import Clientes from './pages/admin/Clientes';
import Mensageria from './pages/admin/Mensageria';
import Configuracoes from './pages/admin/Configuracoes';
import CardapioCliente from './pages/cliente/Cardapio';
import MeusPedidos from './pages/cliente/MeusPedidos';
import NovoPedido from './pages/cliente/NovoPedido';
import AguardandoAprovacao from './pages/cliente/AguardandoAprovacao';
import AcompanharPedido from './pages/cliente/AcompanharPedido';
import CaixaFullscreen from './pages/admin/CaixaFullscreen';
import EntregadorDashboard from './pages/entregador/Dashboard';
import LoginPDV from './pages/pdv/LoginPDV';
import LayoutPDV from './components/LayoutPDV';
import LoginGarcom from './pages/garcom/LoginGarcom';
import LayoutGarcom from './components/LayoutGarcom';
import Comandas from './pages/garcom/Comandas';
import MesasGarcom from './pages/garcom/Mesas';

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" />
      <Routes>
            {/* Rotas públicas */}
            <Route path="/cardapio" element={<CardapioCliente />} />
            <Route path="/cardapio/:estabelecimentoId" element={<CardapioCliente />} />
            <Route path="/aguardando/:pedidoId" element={<AguardandoAprovacao />} />
            <Route path="/acompanhar/:numero" element={<AcompanharPedido />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* Login PDV */}
            <Route path="/pdv/login" element={<LoginPDV />} />
            {/* Login Garçom */}
            <Route path="/garcom/login" element={<LoginGarcom />} />
        
        {/* Rotas protegidas */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="estabelecimentos" element={<Estabelecimentos />} />
          <Route path="produtos" element={<Produtos />} />
          <Route path="cardapio" element={<Cardapio />} />
          <Route path="categorias" element={<Categorias />} />
          <Route path="adicionais" element={<Adicionais />} />
          <Route path="pedidos" element={<Pedidos />} />
          <Route path="cozinha" element={<Cozinha />} />
          <Route path="entregas" element={<Entregas />} />
          <Route path="caixa" element={<Caixa />} />
          <Route path="financeiro" element={<Financeiro />} />
          <Route path="estoque" element={<Estoque />} />
          <Route path="compras" element={<Compras />} />
          <Route path="cupons" element={<Cupons />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="funcionarios" element={<Funcionarios />} />
          <Route path="entregadores" element={<Entregadores />} />
          <Route path="mensageria" element={<Mensageria />} />
          <Route path="configuracoes" element={<Configuracoes />} />
          <Route path="faturamento" element={<Faturamento />} />
          <Route path="meus-pedidos" element={<MeusPedidos />} />
          <Route path="novo-pedido/:estabelecimentoId" element={<NovoPedido />} />
        </Route>

        {/* Rotas do Entregador */}
        <Route
          path="/entregador"
          element={
            <PrivateRoute>
              <EntregadorDashboard />
            </PrivateRoute>
          }
        />

        {/* Rotas PDV (Frente de Caixa) */}
        <Route
          path="/pdv"
          element={
            <PrivateRoute allowedRoles={['admin', 'estabelecimento', 'operador_caixa']}>
              <LayoutPDV />
            </PrivateRoute>
          }
        >
          <Route index element={<CaixaFullscreen />} />
          <Route path="pedidos" element={<Pedidos />} />
        </Route>

        {/* Rotas Garçom */}
        <Route
          path="/garcom"
          element={
            <PrivateRoute allowedRoles={['admin', 'estabelecimento', 'garcom']}>
              <LayoutGarcom />
            </PrivateRoute>
          }
        >
          <Route index element={<Comandas />} />
          <Route path="mesas" element={<MesasGarcom />} />
        </Route>
        
        {/* Rota raiz - redireciona para cardápio */}
        <Route path="/" element={<Navigate to="/cardapio" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;

